export default class ImageDownloadIncludeLocator {
  public idImageDownloadIncludeLocator: number = 0;
  public locatorName: string = "";
}
